{
    "Profile_Policy_Sales.salesStats": "Sales Stats",
    "Profile_Policy_Sales.leadDetails": "Lead Details",
    "Profile_Policy_Sales.leadScore": "Lead Score",
    "Profile_Policy_Sales.rejectedReason": "Rejected Reason",
    "Profile_Policy_Sales.lostReason": "Lost Reason",
    "Profile_Policy_Sales.dealScore": "Deal Score",
    "Profile_Policy_Sales.annualSavings": "Annual Savings"
}
